import useSWR, { SWRResponse, useSWRConfig } from "swr";
import { UserInvoiceIssuer, UserInvoiceSetting } from "../types";
import { SWRConfiguration } from "swr";

export const useIssuers = (
    clubSlug?: string,
    all: boolean = false,
    config: SWRConfiguration | null = null
): { issuers: UserInvoiceIssuer[] } & SWRResponse<{ data: UserInvoiceIssuer[] }> => {
    const data = useSWR(clubSlug ? `invoice/${clubSlug}/issuer${all ? "/all" : ""}` : null, null, config);
    const issuers = data.data?.data || [];
    return { ...data, issuers };
};

export const useMutateIssuers = (clubSlug: string) => {
    const { mutate } = useSWRConfig();

    return () => {
        mutate(`invoice/${clubSlug}/issuer`);
        mutate(`invoice/${clubSlug}/issuer/all`);
    };
};

export const useIssuerSetting = (
    clubSlug?: string,
    issuer?: { id: number; [x: string]: any },
    config: SWRConfiguration | null = null
): { issuerSetting: UserInvoiceSetting } & SWRResponse<{ data: UserInvoiceSetting }> => {
    const data = useSWR(clubSlug && issuer ? `invoice/${clubSlug}/setting/${issuer.id}` : null, null, config);
    const issuerSetting = data.data?.data || {};
    return { ...data, issuerSetting };
};
